export const TABLE_DENSITY = {
  table: 'text-[11px] leading-tight',
  head: 'px-2 py-1.5 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500',
  cell: 'px-2 py-1.5 align-top',
  row: 'group border-b border-slate-100 transition-all hover:bg-indigo-50/35',
  muted: 'text-[10px] text-slate-500',
  badge: 'text-[10px]',
  code: 'rounded bg-slate-100 px-1.5 py-0.5 text-[10px]',
};

export const COMPACT_ACTION_BUTTONS = {
  icon: 'h-7 w-7 p-0',
  tab: 'h-7 px-2 text-[10px]',
  ghost: 'h-7 rounded-md px-2 text-[10px]',
  outline: 'h-7 rounded-md px-2 text-[10px]',
};

export const COMPACT_FILTERS = {
  container: 'flex flex-wrap items-end gap-3',
  label: 'text-[10px] uppercase tracking-[0.14em] text-slate-500',
  control: 'mt-1 h-9 text-sm',
};
